import { forwardRef } from 'react'

import resolveTailwindClasses from '../utils/resolveTailwindClasses'

export type WeightTextType = 'heavy' | 'bold' | 'semibold' | 'regular' | 'light'
export type WeightHeadingType = 'black' | 'bold' | 'regular' | 'light'

export type TypographyProps = {
  className?: string
  weight?: WeightTextType | WeightHeadingType
  Component?: React.ElementType
} & React.HTMLAttributes<HTMLParagraphElement>

/**
 * @group Components
 * @category Atoms
 */
export const Typography = forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ className, weight = 'regular', Component = 'p', children, ...props }, ref) => {
    return (
      <Component className={resolveTailwindClasses(className)} ref={ref} weight={weight} {...props}>
        {children}
      </Component>
    )
  }
)

Typography.displayName = 'Typography'
